import React from "react";
import { PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
export const ReportTypeDescription = ({ reportType }) => {
    const shouldUseInlinePriceLabel = Boolean(reportType.priceInlineLabel);
    return (React.createElement(PeekStack, { direction: "column", gap: 0.5, textAlign: "left" },
        React.createElement(PeekStack, { direction: "row", gap: 0.5, alignItems: "baseline", flexWrap: "wrap" },
            React.createElement(PeekTypography, { variant: "h1", fontWeight: "fontWeightMedium" }, reportType.priceValue),
            shouldUseInlinePriceLabel && (React.createElement(PeekTypography, { variant: "h4", fontWeight: "fontWeightMedium" }, reportType.priceInlineLabel))),
        reportType.priceSubLabel && (React.createElement(PeekTypography, { variant: "h4", color: "info.main", fontWeight: reportType.isPrimaryAction ? "fontWeightMedium" : "fontWeightRegular" }, reportType.priceSubLabel))));
};
export default ReportTypeDescription;
